import { SummaryStatBadge } from "../../../utils/integrationConfigData";

interface StatsCardProps {
  title: string;
  badge: SummaryStatBadge;
  icon: string;
  detail?: string;
}

const StatsCard = ({ title, badge, icon, detail }: StatsCardProps) => {
  const value = badge?.value != null && badge.value !== "" ? badge.value : "—";

  return (
    <article className="ic-overview-stat">
      <span className="ic-overview-stat-icon" aria-hidden="true">
        <i className={icon}></i>
      </span>
      <div className="ic-overview-stat-copy">
        <p className="ic-overview-stat-value">{value}</p>
        <h3 className="ic-overview-stat-title">{title}</h3>
        {detail && (
          <p className="ic-overview-stat-detail" title={detail}>
            {detail}
          </p>
        )}
      </div>
    </article>
  );
};

export default StatsCard;
